module.exports = __webpack_public_path__ + "img/d4a8d2df38d7509685233160827a378c.png";